<template>
  <div class="flex flex-col items-center">
    <RevButton
      full-width="always"
      :icon="IconExternalLink"
      target="_blank"
      :to="PARTNER_WEBSITE_URL[policy.offer.partnerName]"
      :tracking="{
        zone: TRACKING_ZONES.POLICY_DETAILS,
        name: 'get-help',
      }"
      variant="secondary"
    >
      {{ i18n(translations.help) }}
    </RevButton>

    <RevButton
      v-if="displayCancelButton"
      class="mb-8 mt-12"
      :disabled="disableCancelButton"
      full-width="always"
      :to="{
        type: 'internal',
        name: ROUTE_NAMES.DASHBOARD.MY_ORDERS.WITHDRAW.INSURANCES,
        params: {
          orderId: orderline.orderId,
          orderlineId: orderline.badoomId,
        },
      }"
      :tracking="{
        zone: TRACKING_ZONES.POLICY_DETAILS,
        name: 'cancel-policy',
      }"
      variant="secondary"
    >
      {{ i18n(translations.cancel) }}
    </RevButton>

    <div
      v-if="displayCancelButton && disableCancelButton"
      class="text-static-default-low caption"
    >
      {{ i18n(translations.cancelDisabledExplanation) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevButton } from '@ds/components/Button'
import { IconExternalLink } from '@ds/icons/IconExternalLink'

import { ROUTE_NAMES } from '~/scopes/dashboard/constants'
import {
  PARTNER_WEBSITE_URL,
  TRACKING_ZONES,
} from '~/scopes/dashboard/services-hub/constant'
import type { PolicyDetails } from '~/scopes/dashboard/services-hub/types'

import translations from './HelpAndCancelButtons.translations'

const i18n = useI18n()
const { marketplace } = useMarketplace()

const props = defineProps<{
  policy: PolicyDetails['policy']
  orderline: PolicyDetails['orderline']
}>()

const displayCancelButton = computed(() => {
  if (
    props.policy.state === 'ACTIVE' ||
    props.policy.state === 'ON_HOLD' ||
    props.policy.state === 'NOT_STARTED'
  ) {
    return true
  }

  return false
})

const disableCancelButton = computed(() => {
  if (props.policy.startDate) {
    const policyStartDate = new Date(props.policy.startDate)
    const currentDate = new Date()

    const oneYearInMs = 365 * 24 * 60 * 60 * 1000
    if (currentDate.getTime() - policyStartDate.getTime() > oneYearInMs) {
      return false
    }
  }

  if (
    marketplace.marketplaceCode === 'EU' &&
    !props.policy.withinWithdrawalPeriod
  ) {
    return true
  }

  return false
})
</script>
